import { Avatar, Divider } from "antd";
import StarIcon from "../../../../Theme/CustomIcons/Icons/Support,Like,Question/StarIcon";

export const LColCard = [
  // {
  //   id: 1,
  //   key: "geographicalSetting",
  //   title: "Geographical Setting",
  //   content:
  //     "Set your company's location and time zone to ensure accurate timekeeping and compliance.",
  // },
  {
    id: 2,
    key: "moduleSelection",
    title: "Module Selection",
    content:
      "Select modules customized to your company's specific needs and requirements.",
  },

  {
    id: 3,
    key: "advanced_leave",
    title: "Leaves",
    content:
      "Customize your leave policies and types to align with your company's needs and regulations.",
  },
  // {
  //   id: 4,
  //   key: "geo_tracking",
  //   title: "Geo Tracking",
  //   content:
  //     "Answer a couple of questions and we will setup your account for you",
  // },
  {
    id: 5,
    key: "payroll",
    title: "Pay Breakdown",
    content:
      "Configure payroll breakdowns, including salary structures and benefits, for accurate payroll processing.",
  },
  {
    id: 6,
    key: "inviteEmployee",
    title: "Invite Employee",
    content:
      "Easily add and invite your employees to the platform to get them onboarded and started quickly.",
  },
];
export const modulesArr = [
  // {
  //   name: "Training",
  //   value: "training",
  //   image: "/pics/Onboarding_icons/Training.png",
  //   description:
  //     "Track employee work hours for efficient payroll and reporting.",
  //   mandatory: true,
  // },
  // {
  //   name: "Documents",
  //   value: "documents",
  //   image: "/pics/Onboarding_icons/Documents.png",
  //   description:
  //     "Track employee work hours for efficient payroll and reporting.",
  //   mandatory: true,
  // },
  {
    name: "Documents",
    value: "new_document",
    image: "/pics/Onboarding_icons/Document_Icon.png",
    description: "Manage and store all employee-related documents securely.",
    mandatory: true,
  },
  {
    name: "Air Ticket Reimbursement",
    value: "airTicket",
    image: "/pics/Onboarding_icons/Air_Ticket_Reimburse_Icon.png",
    description:
      "Handle and reimburse employee air ticket expenses efficiently.",
    mandatory: true,
  },
  {
    name: "Timesheet Management",
    value: "time",
    image: "/pics/Onboarding_icons/Timesheet_Management_Icon.png",
    description:
      "Track employee work hours for efficient payroll and reporting.",
    mandatory: true,
  },
  {
    name: "Company Announcement",
    value: "announcement",
    image: "/pics/Onboarding_icons/Announcement_Icon.png",
    description:
      "Broadcast company-wide updates, events, and important announcements seamlessly.",
    mandatory: true,
  },
  {
    name: "Roster Management",
    value: "shift",
    image: "/pics/Onboarding_icons/Roster_Management_Icon.png",
    description:
      "Effortlessly schedule and manage employee shifts for optimized operations.",
    mandatory: true,
  },
  {
    name: "Recruitment",
    value: "recruitment",
    image: "/pics/Onboarding_icons/Recruitment_Icon.png",
    description:
      "Source, attract, and onboard top talents for organizational growth.",
    mandatory: true,
  },
  {
    name: "Multiple Recruitment Company",
    value: "recruitment_companies",
    image: "/pics/Onboarding_icons/Multi_Recruiting_Company_Icon.png",
    description:
      "Manage recruitment processes for multiple companies concurrently with ease.",
    mandatory: true,
  },

  {
    name: "Geo Tracking",
    value: "geo_tracking",
    image: "/pics/Onboarding_icons/Leave_Management_Icon.png",
    description:
      "Monitor and track employee locations for operational efficiency.",
    mandatory: false,
  },
  {
    name: "Leave Management",
    value: "advanced_leave",
    image: "/pics/Onboarding_icons/Leave_Management_Icon.png",
    description:
      "Efficiently manage employee leave requests and approvals for smooth operations.",
    mandatory: false,
  },
  {
    name: "Reporting & Analytics",
    value: "report",
    image: "/pics/Onboarding_icons/Reporting_and_analysis_Icon.png",
    description:
      "Generate comprehensive reports and analyze data for strategic decision-making.",
    mandatory: true,
  },
  {
    name: "Payroll Components",
    value: "payroll",
    image: "/pics/Onboarding_icons/Payroll_Management_Icon.png",
    description:
      "Automate payroll processing for accurate and timely salary disbursement.",
    mandatory: true,
  },

  // {
  //   name: "Time Tracking Via Desktop",
  //   value: "time_tracking_Desktop",
  //   image: "/pics/Onboarding_icons/Time_Tracking_via_Desktop_Icon.png",
  //   description:
  //     "Track employee work hours for efficient payroll and reporting.",
  //   mandatory: true,
  // },
  {
    name: "Time Tracking Via Mobile",
    value: "time_tracking_mobile",
    image: "/pics/Onboarding_icons/Time_Tracking_via_Mobile_Icon.png",
    description:
      "Track employee work hours conveniently through mobile devices for efficiency.",
    mandatory: true,
  },

  {
    name: "Employee Onboarding Task",
    value: "emp_onboarding",
    image: "/pics/Onboarding_icons/Employee_Onboarding_Icon.png",
    description: "Streamline the onboarding process for new hires with ease.",
    mandatory: false,
  },
  {
    name: "Letter Request",
    value: "letter_request",
    image: "/pics/Onboarding_icons/Letter_Request_Icon.png",
    description:
      "Request and manage official letters efficiently within the organization.",
    mandatory: true,
  },
  // {
  //   name: "Project",
  //   value: "project",
  //   image: "/pics/Onboarding_icons/Project_Icon.png",
  //   description:
  //     "Track employee work hours for efficient payroll and reporting.",
  //   mandatory: true,
  // },
  // {
  //   name: "To Do",
  //   value: "todos",
  //   image: "/pics/Onboarding_icons/To_Do_Icon.png",
  //   description:
  //     "Track employee work hours for efficient payroll and reporting.",
  //   mandatory: true,
  // },
];

export const education = [
  "recruitment",
  "report",
  "shift",
  "training",
  "announcement",
  "time",
  "advanced_leave",
  "payroll",
  "time_tracking_mobile",
  "emp_onboarding",
  "letter_request",
];
export const recruitment = ["announcement", "recruitment", "advanced_leave"];
export const hospitality = [
  "time",
  "announcement",
  "shift",
  "recruitment",
  "advanced_leave",
  "report",
  "payroll",
  "time_tracking_mobile",
  "emp_onboarding",
];
export const defaultIndustry = [
  "time",
  "announcement",
  "project",
  "time_tracking_mobile",
  // "time_tracking_desktop",
  "recruitment",
  "report",
  "todos",
  "payroll",
  "advanced_leave",
];

// GeoTracking
export const GeoTrackingColumns = [
  {
    title: "Branch Code",
    dataIndex: "branchCode",
    key: "branchCode",
    visible: true,
    fixed: "left",
    // width: 100,
  },
  {
    title: "Branch Name",
    dataIndex: "branchName",
    key: "branchName",
    visible: true,
    // width: 180,
  },
  {
    title: "Location Based Attendance",
    dataIndex: "locationBased",
    key: "locationBased",
    align: "center",
    visible: true,
    // width: 120,
  },
  {
    title: "QR Based Attendance",
    dataIndex: "qrBased",
    key: "qrBased",
    align: "center",
    visible: true,
    // width: 120,
  },
  {
    title: "Auto Checkout",
    dataIndex: "autoCheckingOut",
    key: "autoCheckingOut",
    align: "center",
    visible: true,
    // width: 120,
  },

  {
    title: "Longitude",
    dataIndex: "longitude",
    key: "longitude",
    // width: 100,
    align: "center",
    visible: true,
  },
  {
    title: "Latitude",
    dataIndex: "latitude",
    key: "latitude",
    align: "center",
    // width: 100,
    visible: true,
  },
  {
    title: "Radius (Meter)",
    dataIndex: "radius",
    key: "radius",
    align: "center",
    // width: 100,
    visible: true,
  },
  {
    title: "Opening Time",
    dataIndex: "openTime",
    key: "openTime",
    align: "center",
    // width: 100,
    visible: true,
  },
  {
    title: "Closing Time",
    dataIndex: "closeTime",
    key: "closeTime",
    align: "center",
    // width: 100,
    visible: true,
  },
  {
    title: "Auto Checkout Time",
    dataIndex: "autoCheckoutTime",
    key: "autoCheckoutTime",
    align: "center",
    // width: 140,
    visible: true,
  },
  {
    title: "Action",
    dataIndex: "action",
    key: "action",
    fixed: "right",
    // width: 60,
    align: "center",
    visible: true,
  },
];
// Leave
export const leaves = [
  {
    typeName: "Sick leave",
    color: "#e26b17",
    icon: "Calendar",
    leaveType: "paid",
    balanceBased: "balanceBased",
    entitlement: [
      {
        entitlementEffectiveAfterValue: 0,
        entitlementEffectiveAfterUnit: "year",
        entitlementEffectiveAfterFrom: "dateOfJoining",
        entitlementAccrualStatus: true,
        entitlementResetStatus: true,
        entitlementAccrualUnit: "yearly",
        entitlementAccrualDate: 1,
        entitlementAccrualMonth: "January",
        entitlementAccrualNumberOfDays: 0,
        entitlementAccrualPhase: "currentAccrual",
        entitlementResetUnit: "yearly",
        entitlementResetDate: "lastDate",
        entitlementResetMonth: "December",
        entitlementCarryForwardType: "carryForward",
        entitlementCarryForwardValue: 0,
        entitlementCarryForwardSubType: "percentage",
        entitlementEnchasementValue: 0,
        entitlementEnchasementType: "percentage",
        entitlementOpeningBalance: 15,
      },
    ],
    leaveApplicableSettingName: "Sick leave Applicable",
    leaveExceptionsSettingName: "Sick leave Exception",
    entitlementArr: [
      {
        entitlementEffectiveAfterValue: 0,
        entitlementEffectiveAfterUnit: "year",
        entitlementEffectiveAfterFrom: "dateOfJoining",
        entitlementAccrualStatus: true,
        entitlementResetStatus: true,
        entitlementAccrualUnit: "yearly",
        entitlementAccrualDate: 1,
        entitlementAccrualMonth: "January",
        entitlementAccrualNumberOfDays: 0,
        entitlementAccrualPhase: "currentAccrual",
        entitlementResetUnit: "yearly",
        entitlementResetDate: "lastDate",
        entitlementResetMonth: "December",
        entitlementCarryForwardType: "carryForward",
        entitlementCarryForwardValue: 0,
        entitlementCarryForwardSubType: "percentage",
        entitlementEnchasementValue: 0,
        entitlementEnchasementType: "percentage",
        entitlementOpeningBalance: 15,
      },
    ],
    createEntitlement: true,
    createRestrictions: false,
  },
  {
    typeName: "Annual leave",
    color: "#e26b17",
    icon: "Calendar",
    leaveType: "paid",
    balanceBased: "balanceBased",
    entitlement: [
      {
        entitlementEffectiveAfterValue: 0,
        entitlementEffectiveAfterUnit: "year",
        entitlementEffectiveAfterFrom: "dateOfJoining",
        entitlementAccrualStatus: true,
        entitlementResetStatus: true,
        entitlementAccrualUnit: "yearly",
        entitlementAccrualDate: 1,
        entitlementAccrualMonth: "January",
        entitlementAccrualNumberOfDays: 0,
        entitlementAccrualPhase: "currentAccrual",
        entitlementResetUnit: "yearly",
        entitlementResetDate: "lastDate",
        entitlementResetMonth: "December",
        entitlementCarryForwardType: "carryForward",
        entitlementCarryForwardValue: 0,
        entitlementCarryForwardSubType: "percentage",
        entitlementEnchasementValue: 0,
        entitlementEnchasementType: "percentage",
        entitlementOpeningBalance: 15,
      },
    ],
    leaveApplicableSettingName: "Sick leave Applicable",
    leaveExceptionsSettingName: "Sick leave Exception",
    entitlementArr: [
      {
        entitlementEffectiveAfterValue: 0,
        entitlementEffectiveAfterUnit: "year",
        entitlementEffectiveAfterFrom: "dateOfJoining",
        entitlementAccrualStatus: true,
        entitlementResetStatus: true,
        entitlementAccrualUnit: "yearly",
        entitlementAccrualDate: 1,
        entitlementAccrualMonth: "January",
        entitlementAccrualNumberOfDays: 0,
        entitlementAccrualPhase: "currentAccrual",
        entitlementResetUnit: "yearly",
        entitlementResetDate: "lastDate",
        entitlementResetMonth: "December",
        entitlementCarryForwardType: "carryForward",
        entitlementCarryForwardValue: 0,
        entitlementCarryForwardSubType: "percentage",
        entitlementEnchasementValue: 0,
        entitlementEnchasementType: "percentage",
        entitlementOpeningBalance: 15,
      },
    ],
    createEntitlement: true,
    createRestrictions: false,
  },
];
export const payrolls = [
  {
    categoryName: "Basic",
    archive: false,
  },
  {
    categoryName: "Transportation allowance",
    archive: false,
  },
  {
    categoryName: "House allowance",
    archive: false,
  },
];
export const testimonials = [
  {
    key: 1,
    info: (
      <div>
        <span
          style={{ fontSize: "16px", overflowY: "auto", maxHeight: "120px" }}
        >
          "MaxHR is perfect for restaurant staff. It's a straightforward app for
          clocking in and out, with easy access to leave requests. Their team is
          incredibly responsive; any issue is swiftly resolved with just a
          message. Thanks, MaxHR team!"
        </span>{" "}
        <Divider />
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <div
            style={{
              display: "flex",
              gap: "10px",
              alignItems: "center",
            }}
          >
            {" "}
            <Avatar
              size={30}
              icon={<img alt="" src={"/pics/testimonials/Susrita.jpg"} />}
              style={{ background: "#260b3b", color: "white" }}
            />
            <div
              style={{
                display: "flex",

                flexDirection: "column",
              }}
            >
              <span
                style={{
                  color: "#F4775A",
                  fontSize: "14px",
                  gap: "8px",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                {" "}
                Susrita
              </span>
              <span style={{ fontSize: "13px" }}>Island Chippy</span>
            </div>
          </div>{" "}
          <span>
            {[...Array(5)].map((_, index) => (
              <StarIcon
                key={index}
                style={{ color: "rgb(244, 126, 99)", fontSize: "20px" }}
              />
            ))}
          </span>
        </div>
      </div>
    ),
  },
  {
    key: 2,
    info: (
      <div>
        <span
          style={{ fontSize: "16px", overflowY: "auto", maxHeight: "120px" }}
        >
          "We implemented Max - HRMS, which streamlines HR tasks like
          onboarding, scheduling, leave approvals, and payroll. The QR
          attendance feature is efficient, though there was a learning curve. It
          saves time and boosts employee satisfaction."
        </span>
        <Divider />
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <div
            style={{
              display: "flex",
              gap: "10px",
              alignItems: "center",
            }}
          >
            {" "}
            <Avatar
              size={30}
              icon={<img alt="" src={"/pics/login/pic_6.jpg"} />}
              style={{ background: "#260b3b", color: "white" }}
            />
            <div
              style={{
                display: "flex",

                flexDirection: "column",
              }}
            >
              <span
                style={{
                  color: "#F4775A",
                  fontSize: "14px",
                  gap: "8px",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                {" "}
                Yusuf Khalid
              </span>
              <span style={{ fontSize: "13px" }}>Gates Hospitality</span>
            </div>
          </div>{" "}
          <span>
            {[...Array(5)].map((_, index) => (
              <StarIcon
                key={index}
                style={{ color: "rgb(244, 126, 99)", fontSize: "20px" }}
              />
            ))}
          </span>
        </div>
      </div>
    ),
  },
  {
    key: 3,
    info: (
      <div>
        <span
          style={{ fontSize: "16px", overflowY: "auto", maxHeight: "120px" }}
        >
          "We are scaling up, and our existing methods of HR operations were
          outdated. We needed a better system. We wanted to reduce costs,
          provide a better work experience, and improve the overall efficiency
          of our HR processes."
        </span>
        <Divider />
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          {" "}
          <div
            style={{
              display: "flex",
              gap: "10px",
              alignItems: "center",
            }}
          >
            {" "}
            <Avatar
              size={30}
              icon={<img alt="" src={"/pics/testimonials/Ali_Rayan.jpg"} />}
              style={{ background: "#260b3b", color: "white" }}
            />
            <div
              style={{
                display: "flex",

                flexDirection: "column",
              }}
            >
              <span
                style={{
                  color: "#F4775A",
                  fontSize: "14px",
                  gap: "8px",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                {" "}
                Ali Rehan
              </span>
              <span style={{ fontSize: "13px" }}>Valeem</span>
            </div>
          </div>{" "}
          <span>
            {[...Array(5)].map((_, index) => (
              <StarIcon
                key={index}
                style={{ color: "rgb(244, 126, 99)", fontSize: "20px" }}
              />
            ))}
          </span>
        </div>
      </div>
    ),
  },
  {
    key: 4,
    info: (
      <div>
        <span
          style={{ fontSize: "16px", overflowY: "auto", maxHeight: "120px" }}
        >
          "A centralized system to manage productivity, performance and
          well-being"
        </span>
        <Divider />
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <div
            style={{
              display: "flex",
              gap: "10px",
              alignItems: "center",
            }}
          >
            {" "}
            <Avatar
              size={30}
              icon={<img alt="" src={"/pics/testimonials/Alina.jpg"} />}
              style={{ background: "#260b3b", color: "white" }}
            />
            <div
              style={{
                display: "flex",

                flexDirection: "column",
              }}
            >
              <span
                style={{
                  color: "#F4775A",
                  fontSize: "14px",
                  gap: "8px",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                {" "}
                Alina R
              </span>
              <span style={{ fontSize: "13px" }}>Energia Middle East</span>
            </div>
          </div>{" "}
          <span>
            {[...Array(5)].map((_, index) => (
              <StarIcon
                key={index}
                style={{ color: "rgb(244, 126, 99)", fontSize: "20px" }}
              />
            ))}
          </span>
        </div>
      </div>
    ),
  },
  {
    key: 5,
    info: (
      <div>
        <span
          style={{ fontSize: "16px", overflowY: "auto", maxHeight: "120px" }}
        >
          "Max has simplified so many of our company's HR tasks. We couldn't
          imagine going back to the way we used to manage our HR processes."
        </span>
        <Divider />
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <div
            style={{
              display: "flex",
              gap: "10px",
              alignItems: "center",
            }}
          >
            {" "}
            <Avatar
              size={30}
              icon={<img alt="" src={"/pics/testimonials/Usman.jpg"} />}
              style={{ background: "#260b3b", color: "white" }}
            />
            <div
              style={{
                display: "flex",

                flexDirection: "column",
              }}
            >
              <span
                style={{
                  color: "#F4775A",
                  fontSize: "14px",
                  gap: "8px",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                {" "}
                Usman bin Noaman
              </span>
              <span style={{ fontSize: "13px" }}>Magellan</span>
            </div>
          </div>{" "}
          <span>
            {[...Array(5)].map((_, index) => (
              <StarIcon
                key={index}
                style={{ color: "rgb(244, 126, 99)", fontSize: "20px" }}
              />
            ))}
          </span>
        </div>
      </div>
    ),
  },
  {
    key: 6,
    info: (
      <div>
        <span
          style={{ fontSize: "16px", overflowY: "auto", maxHeight: "120px" }}
        >
          "It's great to have our attendance, timseheets and employee database
          all in a single location. Max has a very good support system."
        </span>
        <Divider />
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          {" "}
          <div
            style={{
              display: "flex",
              gap: "10px",
              alignItems: "center",
            }}
          >
            {" "}
            <Avatar
              size={30}
              icon={<img alt="" src={"/pics/testimonials/Zain.jpg"} />}
              style={{ background: "#260b3b", color: "white" }}
            />
            <div
              style={{
                display: "flex",

                flexDirection: "column",
              }}
            >
              <span
                style={{
                  color: "#F4775A",
                  fontSize: "14px",
                  gap: "8px",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                {" "}
                Syed Zain
              </span>
              <span style={{ fontSize: "13px" }}>EasyFresh Technologies</span>
            </div>
          </div>{" "}
          <span>
            {[...Array(5)].map((_, index) => (
              <StarIcon
                key={index}
                style={{ color: "rgb(244, 126, 99)", fontSize: "20px" }}
              />
            ))}
          </span>
        </div>
      </div>
    ),
  },
];
export const trialData = [
  {
    id: 1,
    key: "empAttendanceManage",
    title: (
      <span style={{ fontSize: "13px", fontWeight: "bold" }}>
        Employee Attendance Management
      </span>
    ),
    content: (
      <span style={{ fontSize: "13px" }}>
        Keep track of employees' clock-ins, shifts, and leave applications.
      </span>
    ),
    icon: (
      <img
        src="/pics/trailIcons/Emp.jpg"
        style={{
          marginRight: "5px",
          width: "32px",
          height: "32px",
          marginRight: "8px",
        }}
        alt="Employee Attendance Management"
      />
    ),
  },
  {
    id: 2,
    key: "payrollAutomation",
    title: (
      <span style={{ fontSize: "13px", fontWeight: "bold" }}>
        Payroll Automation
      </span>
    ),
    content: (
      <span style={{ fontSize: "13px" }}>
        Wave goodbye to payroll headaches! Our system ensures a precise
        three-step payroll calculator.
      </span>
    ),
    icon: (
      <img
        src="/pics/trailIcons/Calculator.jpg"
        style={{
          marginRight: "5px",
          width: "32px",
          height: "32px",
          marginRight: "8px",
        }}
        alt="Payroll Automation"
      />
    ),
  },
  {
    id: 3,
    key: "seamlessOnboarding",
    title: (
      <span style={{ fontSize: "13px", fontWeight: "bold" }}>
        Seamless Onboarding
      </span>
    ),
    content: (
      <span style={{ fontSize: "13px" }}>
        Our smooth onboarding process sets the stage for success from day one.
      </span>
    ),
    icon: (
      <img
        src="/pics/trailIcons/Onboard-file.jpg"
        style={{
          marginRight: "5px",
          width: "32px",
          height: "32px",
          marginRight: "8px",
        }}
        alt="Seamless Onboarding"
      />
    ),
  },
  {
    id: 4,
    key: "paperlessDocumentManagement",
    title: (
      <span style={{ fontSize: "13px", fontWeight: "bold" }}>
        Paperless Document Management
      </span>
    ),
    content: (
      <span style={{ fontSize: "13px" }}>
        Ditch the paperwork and embrace the digital age! Keep all your HR
        documents organized and accessible with just a few clicks.
      </span>
    ),
    icon: (
      <img
        src="/pics/trailIcons/Laptop.jpg"
        style={{
          marginRight: "5px",
          width: "32px",
          height: "32px",
          marginRight: "8px",
        }}
        alt="Paperless Document Management"
      />
    ),
  },
  {
    id: 5,
    key: "expenseReimbursement",
    title: (
      <span style={{ fontSize: "13px", fontWeight: "bold" }}>
        Expense Reimbursement
      </span>
    ),
    content: (
      <span style={{ fontSize: "13px" }}>
        Streamline expense management and reimbursements, ensuring timely
        payments.
      </span>
    ),
    icon: (
      <img
        src="/pics/trailIcons/Gold.jpg"
        style={{
          marginRight: "5px",
          width: "32px",
          height: "32px",
          marginRight: "8px",
        }}
        alt="Expense Reimbursement"
      />
    ),
  },
  {
    id: 6,
    key: "employeeRecruitment",
    title: (
      <span style={{ fontSize: "13px", fontWeight: "bold" }}>
        Employee Recruitment
      </span>
    ),
    content: (
      <span style={{ fontSize: "13px" }}>
        Attract top-tier talent with our job board and AI-driven candidate
        matching.
      </span>
    ),
    icon: (
      <img
        src="/pics/trailIcons/Case.jpg"
        style={{
          marginRight: "5px",
          width: "32px",
          height: "32px",
          marginRight: "8px",
        }}
        alt="Employee Recruitment"
      />
    ),
  },
];
